import { RequestError } from '@vartion/ui'
import { acceptHMRUpdate, defineStore } from 'pinia'

import type { OrganizationFunction, SearchResponse } from '~/types.ts'

export const useOrganizationFunctions = defineStore('organizationFunctions', {
  state: () => ({
    functions: {} as Record<number, OrganizationFunction>,
    loading: false,
    loaded: false,
  }),

  actions: {
    async fetch() {
      if (this.loaded || this.loading) {
        return
      }

      await this.refresh()
    },

    async refresh() {
      this.loading = true
      try {
        const { data } = await api.post<SearchResponse<OrganizationFunction>>('organization-functions/searches', { organization_id: [stores.organization.id], per_page: 1000 })
        this.functions = keyBy('id', data.data)
      } catch (error) {
        if (error instanceof RequestError && error.response?.status === 419) {
          // Session expired, reload the page to get a new one.
          window.location.reload()
          await delay(10000)

          return
        }
        throw error
      }
      this.loading = false
      this.loaded = true
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOrganizationFunctions, import.meta.hot))
}
